const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'projects',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_offers': true,
        },
    },

    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
    },

    methods: {

        getResourceFilters(storage, resourceFilters, actionKey, fieldCode){
            const parentEntity = this.model.parentEntity = this.model.parentEntity || this.getResourceRegisterContent('parentEntity')
            if(parentEntity && actionKey === 'refreshResources'){
                resourceFilters = resourceFilters || {}

                const {
                    entityID,
                    primaryKey
                } = this.model.parentEntity

                if(primaryKey === 'projectID' && entityID){
                    resourceFilters.filters = resourceFilters.filters || {}
                    resourceFilters.filters.projectID = entityID
                }
            }

            return resourceFilters
        },

        sanitizeResources(storage){
            if(storage.isClient){
                const projectMeta = this.model.projectMeta = {
                    ...((this.resourceData.data || {}).attributes || {})
                }

                // update progress if necessary
                let progress
                this.find('templates_core_progress_progress', c => progress = c)
                if(progress){
                    progress.updateProgressKey(projectMeta.progressKey)
                }

                // which properties is a customer allowed to change?
                this.closest('base_modal_modal', c => {
                    c.triggerFind('projectMetaChanged', {
                        projectMeta,
                    })
                })
            }
        },

        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            const titleParts = []
            if(entityAttributes.startTS)    titleParts.push(`${utils.moment(entityAttributes.startTS).format('DD.MM.YYYY')} -`);
            if(entityAttributes.title)      titleParts.push(entityAttributes.title);
            tabOptions.title = titleParts.join(' ')
            // tabOptions.titleSuffix = ` [${entityID}]`

            return tabOptions
        },

        async saveIfNecessary(confirmationKey){
            confirmationKey = confirmationKey || 'projects.setStatusByCustomer.submitBeforeChangeStatus'

            let form
            this.find('templates_customers_projects_propertiesFormAllInOne', c => form = c)
            if(form && form.isDirty()){

                const decisionContext = await this.performDecision(
                    'confirm',
                    {
                        component:  this,
                        title:      storage.__(`${confirmationKey}.title`),
                        message:    storage.__(`${confirmationKey}.message`),
                        buttons: [
                            {
                                buttonType: 'cancel'
                            },
                            {
                                buttonType: 'yes'
                            }
                        ],
                    }
                ) || {}
                const decision = decisionContext.decision || {}
                if(decision.type !== 'yes'){
                    return
                }

                return form.submit()
            }
        },

        async editStatus(baseActionKey, context, mode, actionBossComponent, additionalData, submitActionContext){
            let newStatus
            if(mode === 'request') newStatus = 'request';
            else if(mode === 'order') newStatus = 'ordered';
            else if(mode === 'cancel') newStatus = 'canceled';

            if(
                baseActionKey === 'editStatus_project' &&
                this.actions[baseActionKey] &&
                newStatus
            ){
                // newly created projects may have had no change to refresh after submitting their data.
                // to prevent multi-submits of the very same project the previously preformed submitActionContext may have been given to use it's results (like primaryKeys) and so on.
                submitActionContext = submitActionContext || await this.saveIfNecessary('projects.setStatusByCustomer.submitBeforeChangeStatus')

                let {
                    projectID,
                    status,
                } = (this.resourceData.data || {}).attributes || {}

                let closeModalOfNewlyCreatedProjects = false
                if(!projectID){
                    const attributes = (((submitActionContext || {}).response || {}).data || {}).attributes || {}
                    projectID = attributes.projectID
                    status = attributes.status
                    closeModalOfNewlyCreatedProjects = true
                }

                if(!projectID){
                    return
                }

                let editStatusGranted = true
                if(newStatus === 'canceled'){
                    const decisionContext = await this.performDecision(
                        'confirm',
                        {
                            component:  this,
                            title:      storage.__(`projects.setStatusByCustomer.${mode}.title`),
                            message:    storage.__(`projects.setStatusByCustomer.${mode}.message`),
                        }
                    ) || {}
                    const decision = decisionContext.decision || {}
                    editStatusGranted = decision.type === 'yes'
                } else if(status === 'draft'){
                    const decisionContext = await this.performDecision(
                        'confirm',
                        {
                            component:  this,
                            title:      storage.__(`projects.setStatusByCustomer.${mode}.title`),
                            message:    storage.__(`projects.setStatusByCustomer.${mode}.message`),
                        }
                    ) || {}
                    const decision = decisionContext.decision || {}
                    editStatusGranted = decision.type === 'yes'
                }
                if(editStatusGranted && newStatus === 'ordered'){
                    const baseUrl = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).documentBaseUrl || '').replace(/\/+$/g, '')
                    const termsPath = String((((((storage || {}).app || {}).service || {}).config || {}).backOffice || {}).termsPath || '').replace(/^\/+/g, '/')
                    const termsUrl = `${baseUrl}${termsPath}`

                    const decisionContext = await this.performDecision(
                        'confirm',
                        {
                            component:  this,
                            title:      storage.__(`projects.setStatusByCustomer.${mode}.acceptTerms.title`),
                            message:    storage.__(`projects.setStatusByCustomer.${mode}.acceptTerms.message`, { termsUrl }),
                        }
                    ) || {}
                    const decision = decisionContext.decision || {}
                    editStatusGranted = decision.type === 'yes'
                }


                if(editStatusGranted){
                    const editStatusActionContext = await this.performAction(
                        this.prepareAction(baseActionKey, undefined, undefined, {
                            source: {
                                submit: {
                                    data: {
                                        resourceParams: {
                                            projectID,
                                            status: newStatus,
                                        }
                                    }
                                }
                            }
                        })
                    )

                    const response = (editStatusActionContext || {}).response || {}
                    const status = (response.resourceParams || {}).status
                    const isUrgent = ((((response || {}).data || {}).meta || {}).projectMeta || {}).isUrgent

                    if(status === 'request' || status === 'ordered'){
                        if(isUrgent){
                            await this.performDecision(
                                'confirm',
                                {
                                    component:  this,
                                    title:      storage.__(`projects.setStatusByCustomer.thanks.urgent.title`),
                                    message:    storage.__(`projects.setStatusByCustomer.thanks.urgent.message`),
                                    buttons: [
                                        {
                                            buttonType: 'ok',
                                            icon: 'fi fi-check',
                                        },
                                    ],
                                }
                            )
                        } else {
                            await this.performDecision(
                                'confirm',
                                {
                                    component:  this,
                                    title:      storage.__(`projects.setStatusByCustomer.thanks.title`),
                                    message:    storage.__(`projects.setStatusByCustomer.thanks.message`),
                                    buttons: [
                                        {
                                            buttonType: 'ok',
                                            icon: 'fi fi-check',
                                        },
                                    ],
                                }
                            )
                        }
                    }
                }

                if(closeModalOfNewlyCreatedProjects){
                    let modal
                    this.locate('< base_modal_modal', c => modal = c)

                    if(modal){
                        await modal.hide()
                    }
                }
            } else {
                console.error('invalid editStatus call')
            }
        },

        async requestOffer(){
            const userTableAssociates = (((storage || {}).user || {}).data || {}).userTableAssociates || {}
            const customerContact = userTableAssociates.customerContact || {}
            if(!customerContact.confirmed){
                return this.performMessage({
                    messageDisplay: {
                        message: 'error:projects.customer.requestOffer.customerContactConfirmationIsMandatory.message'
                    }
                })
            }

            const submitActionContext = await this.saveIfNecessary('projects.requestOfferByCustomer.submitBeforeRequestOffer')

            let {
                projectID,
            } = (this.resourceData.data || {}).attributes || {}

            let closeModalOfNewlyCreatedProjects = false
            if(!projectID){
                projectID = ((((submitActionContext || {}).response || {}).data || {}).attributes || {}).projectID
                closeModalOfNewlyCreatedProjects = true
            }

            if(!projectID){
                return
            }

            const {response} = await this.performAction(
                this.prepareAction('requestOffer_project', undefined, undefined, {
                    source: {
                        submit: {
                            data: {
                                resourceParams: {
                                    projectID,
                                }
                            }
                        }
                    }
                })
            )

            const offerUrl = (((response || {}).data || {}).attributes || {}).url
            if(offerUrl){
                window.open(offerUrl, '_blank')
            } else {
                await this.performMessage({
                    messageDisplay: {
                        message: 'error:projects.customer.requestOffer.missingUrl.message'
                    }
                })
            }

            if(closeModalOfNewlyCreatedProjects){
                let modal
                this.locate('< base_modal_modal', c => modal = c)

                if(modal){
                    await modal.hide()
                }
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key               = message.heartbeatKey
            const parentEntity      = this.model.parentEntity || {}
            const projectID   = parentEntity.primaryKey === 'projectID' && parentEntity.entityID

            if(refreshers[key] && (
                (
                    (key !== 'resourceChanged.bo_projects' && key !== 'resourceChanged.bo_projectTerms' && key !== 'resourceChanged.bo_offers')
                    ||
                    (projectID && (message.data.projectID == projectID || (message.data.projectIDs || {})[projectID]))
                )
            )){
                this.delayedLastOf('refreshProjectMeta', () => {
                    try {
                        this.performAction('refreshResources')
                            .fail(error => console.error(error))
                    } catch (error){
                        console.error(error)
                    }
                }, 50)
            }
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}